export default "__VITE_ASSET__uMmzDqZp__"